// Panel de la herramienta "Fondo": color de fondo del lienzo.

import { ColorPicker } from './ColorPicker';
import { PanelSheet } from './PanelSheet';
import type { SceneApi } from '../scene/useScene';

interface Props {
  api: SceneApi;
  brandColors?: string[];
  onClose: () => void;
}

export function FondoPanel({ api, brandColors, onClose }: Props) {
  return (
    <PanelSheet title="Fondo" onClose={onClose}>
      <div className="p-3 space-y-2">
        <p className="text-[11px] uppercase tracking-wide font-medium text-[#3C3C43]/55">Color de fondo</p>
        <ColorPicker
          value={api.scene.bg}
          onChange={(c) => api.setBg(c)}
          brandColors={brandColors}
          allowTransparent
          inline
        />
      </div>
    </PanelSheet>
  );
}
